/**
 * Form-related semantic tokens for PrimeNG preset
 * Uses inputTokens from component layer for Figma parity
 */

import { inputTokens, createInputTokens } from '../tokens/components.js';
import * as p from '../tokens/primitives.js';
import { border, focus, surface, text, type SemanticTokens } from '../tokens/semantic.js';

export const forms = {
  form: {
    field: {
      padding: {
        x: inputTokens.base.paddingX,
        y: inputTokens.base.paddingY,
      },
      paddingX: inputTokens.base.paddingX,
      paddingY: inputTokens.base.paddingY,
      background: inputTokens.bg,
      disabled: {
        background: inputTokens.bgDisabled,
      },
      filled: {
        background: surface.canvas,
        hover: {
          background: inputTokens.bgHover,
        },
        focus: {
          background: inputTokens.bgFocus,
        },
      },
      border: {
        color: inputTokens.border,
        radius: inputTokens.base.radius,
        width: '1px',
      },
      hover: {
        border: {
          color: border.strong,
        },
      },
      focus: {
        border: {
          color: inputTokens.borderFocus,
        },
        ring: {
          width: '2px',
          style: 'solid',
          color: focus.ring,
          offset: '2px',
          shadow: 'none',
        },
      },
      invalid: {
        color: text.secondary,
        border: {
          color: border.danger,
        },
        placeholder: {
          color: inputTokens.placeholder,
        },
      },
      color: inputTokens.fg,
      placeholder: {
        color: inputTokens.placeholder,
      },
      shadow: 'none',
      transition: {
        duration: '0.2s',
      },
      sm: {
        fontSize: p.fontSize.sm,
        paddingX: p.spacing[8],
        paddingY: p.spacing[4],
      },
      lg: {
        fontSize: p.fontSize.lg,
        paddingX: p.spacing[16],
        paddingY: p.spacing[8],
      },
    },
  },
  formField: {
    paddingX: inputTokens.base.paddingX,
    paddingY: inputTokens.base.paddingY,
    sm: {
      fontSize: p.fontSize.base,
      paddingX: p.spacing[8],
      paddingY: p.spacing[4],
    },
    lg: {
      fontSize: p.fontSize.base,
      paddingX: p.spacing[16],
      paddingY: p.spacing[8],
    },
    borderRadius: inputTokens.base.radius,
    focusRing: {
      width: '2px',
      style: 'solid',
      color: focus.ring,
      offset: '2px',
      shadow: 'none',
    },
    transitionDuration: '0.2s',
  },
};

export function createForms(s: SemanticTokens, it: ReturnType<typeof createInputTokens>) {
  return {
    form: {
      field: {
        padding: {
          x: it.base.paddingX,
          y: it.base.paddingY,
        },
        paddingX: it.base.paddingX,
        paddingY: it.base.paddingY,
        background: it.bg,
        disabled: {
          background: it.bgDisabled,
        },
        filled: {
          background: s.surface.canvas,
          hover: {
            background: it.bgHover,
          },
          focus: {
            background: it.bgFocus,
          },
        },
        border: {
          color: it.border,
          radius: it.base.radius,
          width: '1px',
        },
        hover: {
          border: {
            color: s.border.strong,
          },
        },
        focus: {
          border: {
            color: it.borderFocus,
          },
          ring: {
            width: '2px',
            style: 'solid',
            color: s.focus.ring,
            offset: '2px',
            shadow: 'none',
          },
        },
        invalid: {
          color: s.text.secondary,
          border: {
            color: s.border.danger,
          },
          placeholder: {
            color: it.placeholder,
          },
        },
        color: it.fg,
        placeholder: {
          color: it.placeholder,
        },
        shadow: 'none',
        transition: {
          duration: '0.2s',
        },
        sm: {
          fontSize: p.fontSize.sm,
          paddingX: p.spacing[8],
          paddingY: p.spacing[4],
        },
        lg: {
          fontSize: p.fontSize.lg,
          paddingX: p.spacing[16],
          paddingY: p.spacing[8],
        },
      },
    },
    formField: {
      paddingX: it.base.paddingX,
      paddingY: it.base.paddingY,
      sm: {
        fontSize: p.fontSize.base,
        paddingX: p.spacing[8],
        paddingY: p.spacing[4],
      },
      lg: {
        fontSize: p.fontSize.base,
        paddingX: p.spacing[16],
        paddingY: p.spacing[8],
      },
      borderRadius: it.base.radius,
      focusRing: {
        width: '2px',
        style: 'solid',
        color: s.focus.ring,
        offset: '2px',
        shadow: 'none',
      },
      transitionDuration: '0.2s',
    },
  };
}
